import React, { Component } from 'react'
import RiskProfileForm from './RiskProfileForm'
import PropTypes from 'prop-types'

export default class RiskProfileWidget extends Component {
  static propTypes = {
    tenant: PropTypes.string.isRequired,
    onboarding: PropTypes.bool,
    scenarioPlanningResultsHandler: PropTypes.func,
    clientId: PropTypes.number.isRequired
  }

  changeHeading (finished) {
    if (finished) {
      $('#risk-heading').text('Your overall risk profile results')
    } else {
      $('#risk-heading').text("Let's determine your risk profile")
    }
  }

  render () {
    return (
      <div>
        <h1 id='risk-heading'>Let's determine your risk profile</h1>
        <RiskProfileForm
          scenarioPlanningResultsHandler={this.props.scenarioPlanningResultsHandler}
          changeHeading={this.changeHeading}
          tenant={this.props.tenant}
          onboarding={this.props.onboarding}
          clientId={this.props.clientId} />
      </div>
    )
  }
}
